import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { LoginPage } from './pages/LoginPage';
import { Dashboard } from './pages/Dashboard';
import { GoalDetailPage } from './pages/GoalDetailPage';
function PrivateRoute({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    user,
    isLoading
  } = useAuth();
  if (isLoading) {
    return <div className="min-h-screen flex items-center justify-center" data-id="element-0">
        <div className="text-white text-xl" data-id="element-1">Loading...</div>
      </div>;
  }
  return user ? <>{children}</> : <Navigate to="/login" data-id="element-2" />;
}
export function App() {
  return <AuthProvider data-id="element-3">
      <BrowserRouter data-id="element-4">
        <Routes data-id="element-5">
          <Route path="/login" element={<LoginPage data-id="element-7" />} data-id="element-6" />
          <Route path="/" element={<PrivateRoute data-id="element-9">
                <Dashboard data-id="element-10" />
              </PrivateRoute>} data-id="element-8" />
          <Route path="/goal/:id" element={<PrivateRoute data-id="element-12">
                <GoalDetailPage data-id="element-13" />
              </PrivateRoute>} data-id="element-11" />
        </Routes>
      </BrowserRouter>
    </AuthProvider>;
}